import _ from 'lodash'

export default ContractService

/** @ngInject */
function ContractService(ContractStatus) {
    const NEGATIVE_BALANCE_THRESHOLD = 1
    const REGULATE_BTN_THRESHOLD = 0
    const SUBSCRIPTION_CONTRACT_FINISHED = [
        ContractStatus.enService,
        ContractStatus.resilie,
        ContractStatus.retracte,
        ContractStatus.annule,
        // ContractStatus.duplicat,
    ]

    const INVOICE_PAGE_ON_CONTRACT_STATUS = [
        ContractStatus.enRecouvrement,
        ContractStatus.resilie,
        ContractStatus.coupe,
        ContractStatus.resiliationDemande,
        ContractStatus.coupureDemande,
    ]

    const isNotFinishedContract = (contract) => SUBSCRIPTION_CONTRACT_FINISHED.indexOf(contract.status) === -1
    const isContractGoalNotDefined = (c) => _.isNil(c.id_ref_goal)
    const isContractNegativeBalance = (balanceThreshold) => (contract) => _.toNumber(_.get(contract, 'contractBalance.balance', 0)) < -_.toNumber(balanceThreshold)

    const findContract = (contracts, contractId) => _.find(contracts, { id: contractId })
    const findFirstGoalNotDefinedContract = (contracts) => _.find(contracts, isContractGoalNotDefined)
    const findFirstNotFinishedContract = (contracts) => _.find(contracts, isNotFinishedContract)
    const findFirstUnpaidContract = (contracts, balanceThreshold = NEGATIVE_BALANCE_THRESHOLD) => _.find(contracts, isContractNegativeBalance(balanceThreshold))

    const getMyAccountStatusFromContract = (contract) => {
        return _.includes(INVOICE_PAGE_ON_CONTRACT_STATUS, _.get(contract, 'status')) ? 'invoice' : 'account'
    }

    return {
        NEGATIVE_BALANCE_THRESHOLD,
        REGULATE_BTN_THRESHOLD,
        isContractNegativeBalance,
        findContract,
        findFirstGoalNotDefinedContract,
        findFirstNotFinishedContract,
        getMyAccountStatusFromContract,
        findFirstUnpaidContract,
    }
}



// WEBPACK FOOTER //
// ./src/services/contract/contract.js